// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__wpZ0n","nav":"style_nav__1bjo1","col":"style_col__tulZ7","item":"style_item__Eey2a","ownership":"style_ownership__nHcfO"};